import { SiteDto } from "../../../types/blastDtos";
import { isMockMode, postBlast, simulateDelay } from "../../api";

export const getSitesForUser = ({ orgId }: { orgId: string }) => {
	if (isMockMode()) {
		const testData = {
			sites: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					subscription: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
						subscriberOrgId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						isDeleted: true,
						isEnabled: true,
						expirationDateUtc: "2023-08-10T02:04:27.595Z",
						lastUpdatedDateUtc: "2023-08-10T02:04:27.595Z",
					},
				},
			],
		};

		return simulateDelay(50, () => testData) as Promise<{
			sites: Array<SiteDto>;
		}>;
	}

	return postBlast(`sites/getforuser`, { orgId }) as Promise<{
		sites: Array<SiteDto>;
	}>;
};
